export default import.meta.ROLLDOWN_FILE_URL_K1daVVNYU_lXF$FdA5v55g